import React from 'react';
import { IconProps } from './types';

export const LineArrowIcon: React.FC<IconProps> = ({
  size = 24,
  strokeWidth = 2.2,
  primaryColor = 'currentColor',
  className,
  title,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={primaryColor}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    role="img"
    aria-label={title}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M20 4l-16 16" />
    <path d="M16 3h5v5" />
  </svg>
);
